import { jsxs as L, Fragment as T, jsx as D } from "react/jsx-runtime";
import { useState as R, useRef as k, useCallback as n, useEffect as j } from "react";
import { Plate as d } from "../plate/Plate.component.js";
import { useMergeThemeVariables as H } from "../utils.js";
const O = {
  "(min-width: 0px)": 20,
  "(min-width: 768px)": 35
}, z = ({
  dropdownMenuClass: y = "",
  leftPlateOffset: E = 0,
  topPlateOffset: v = 0,
  onOpen: s,
  onClose: r,
  renderButton: P,
  renderMenuContent: m,
  plateMinWidth: x,
  theme: b
}) => {
  const [c, p] = R(!1), f = k(null), o = k(null), g = H("plate", d.themeKeys, b), u = n(() => {
    p(!0), s && s();
  }, [s]), e = n(() => {
    p(!1), r && r();
  }, [r]), i = n(
    (t) => {
      t.key === "Escape" && e();
    },
    [e]
  ), l = n(
    (t) => {
      const a = t.composedPath ? t.composedPath() : void 0, h = f.current, w = o.current;
      a && h && !a.includes(h) && w && !a.includes(w) && e();
    },
    [e]
  ), K = n(
    (t) => {
      t.stopPropagation(), c ? e() : u();
    },
    [e, c, u]
  );
  return j(() => (window.addEventListener("click", l, !0), window.addEventListener("keydown", i), () => {
    window.removeEventListener("click", l, !0), window.removeEventListener("keydown", i);
  }), [l, i]), /* @__PURE__ */ L(T, { children: [
    P({
      ref: o,
      onClick: K
    }),
    c && o.current && /* @__PURE__ */ D(
      d,
      {
        ref: f,
        anchor: o.current,
        className: y,
        leftOffset: E,
        topOffset: v,
        horizontalPaddingMedia: O,
        plateMinWidth: x,
        theme: g,
        children: m && m({ close: e })
      }
    )
  ] });
}, C = z;
C.themeKeys = {
  ...d.themeKeys,
  plate: !0
};
export {
  C as Dropdown
};
